export type DailyRewardState = { lastRewardDate: string | null; streak: number };
export type DailyReward = { day: number; gold: number; relicFragments: number };

const DAY = 86_400_000;
const key = (date: Date): string => date.toISOString().slice(0, 10);
const dayNumber = (value: string): number => Date.parse(`${value}T00:00:00Z`) / DAY;

export function canClaimDailyReward(state: DailyRewardState, now: Date): boolean {
  return state.lastRewardDate !== key(now);
}

export function claimDailyReward(state: DailyRewardState, now: Date): {
  state: DailyRewardState;
  reward: DailyReward;
} {
  const today = key(now);
  if (!canClaimDailyReward(state, now)) {
    return { state, reward: { day: state.streak, gold: 0, relicFragments: 0 } };
  }
  const consecutive = state.lastRewardDate !== null &&
    dayNumber(today) - dayNumber(state.lastRewardDate) === 1;
  const streak = consecutive ? state.streak % 7 + 1 : 1;
  return {
    state: { lastRewardDate: today, streak },
    reward: {
      day: streak,
      gold: 50 + streak * 25,
      relicFragments: streak === 7 ? 1 : 0,
    },
  };
}
